import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, FileCheck, Building2, SunMedium, Zap } from 'lucide-react';
export const Sidebar = () => {
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <div className="h-full w-64 border-r bg-background" data-id="element-51">
      <div className="py-4" data-id="element-52">
        <div className="px-3 py-2" data-id="element-53">
          <nav className="space-y-1" data-id="element-54">
            <Link to="/dashboard" className={`flex items-center px-3 py-3 text-sm font-medium rounded-md ${isActive('/dashboard') ? 'bg-pink-100 text-pink-600' : 'text-foreground hover:bg-muted/50'}`} data-id="element-55">
              <Home className="h-5 w-5 mr-3" data-id="element-56" />
              Dashboard
            </Link>
            <Link to="/" className={`flex items-center px-3 py-3 text-sm font-medium rounded-md ${isActive('/') ? 'bg-pink-100 text-pink-600' : 'text-foreground hover:bg-muted/50'}`} data-id="element-57">
              <Users className="h-5 w-5 mr-3" data-id="element-58" />
              Users
            </Link>
            <Link to="/proposals" className={`flex items-center px-3 py-3 text-sm font-medium rounded-md ${isActive('/proposals') ? 'bg-pink-100 text-pink-600' : 'text-foreground hover:bg-muted/50'}`} data-id="element-59">
              <FileCheck className="h-5 w-5 mr-3" data-id="element-60" />
              Proposals
            </Link>
            <Link to="/financing" className={`flex items-center px-3 py-3 text-sm font-medium rounded-md ${isActive('/financing') ? 'bg-pink-100 text-pink-600' : 'text-foreground hover:bg-muted/50'}`} data-id="element-61">
              <Building2 className="h-5 w-5 mr-3" data-id="element-62" />
              Finance Partners
            </Link>
            <Link to="/products" className={`flex items-center px-3 py-3 text-sm font-medium rounded-md ${isActive('/products') ? 'bg-pink-100 text-pink-600' : 'text-foreground hover:bg-muted/50'}`} data-id="element-63">
              <SunMedium className="h-5 w-5 mr-3" data-id="element-64" />
              Products
            </Link>
            <Link to="/electricity" className={`flex items-center px-3 py-3 text-sm font-medium rounded-md ${isActive('/electricity') ? 'bg-pink-100 text-pink-600' : 'text-foreground hover:bg-muted/50'}`} data-id="element-65">
              <Zap className="h-5 w-5 mr-3" data-id="element-66" />
              Electricity Tariffs
            </Link>
          </nav>
        </div>
      </div>
    </div>;
};